import { render, staticRenderFns } from "./Loading2.vue?vue&type=template&id=f86ec0ca&scoped=true&"
import script from "./Loading2.vue?vue&type=script&lang=js&"
export * from "./Loading2.vue?vue&type=script&lang=js&"
import style0 from "./Loading2.vue?vue&type=style&index=0&id=f86ec0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86ec0ca",
  null
  
)

export default component.exports